import React from 'react'
import { X } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export interface FilterChip {
  key: string
  label: string
  value: string
  displayValue?: string
}

interface FilterChipsProps {
  filters: FilterChip[]
  onRemoveFilter: (key: string) => void
  onClearAll: () => void
  className?: string
  showClearAll?: boolean
}

export function FilterChips({ filters, onRemoveFilter, onClearAll, className, showClearAll = true }: FilterChipsProps) {
  if (filters.length === 0) {
    return null
  }

  return (
    <div className={cn('flex flex-wrap items-end gap-2 px-3  rounded-lg ', className)}>
      <div className="flex flex-wrap items-end gap-2 flex-1">
        {filters.map(filter => (
          <Badge key={filter.key} variant="secondary" className="flex items-center gap-1 px-3 py-2 text-sm font-medium bg-blue-100 text-blue-900 hover:bg-blue-200/80">
            <span className="font-semibold">{filter.label}:</span>
            <span>{filter.displayValue || filter.value}</span>
            <Button variant="outline" size="sm" onClick={() => onRemoveFilter(filter.key)} className="h-4 w-4 p-0 ml-1 ">
              <X className="h-4 w-4" />
            </Button>
          </Badge>
        ))}
      </div>

      {showClearAll && filters.length > 1 && (

        <Button variant="default" onClick={onClearAll} className="smAndDown:w-full" disabled={!filters.length}>
          Limpar todos
        </Button>
      )}
    </div>
  )
}
